(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('abookEdit', abookEdit);

    /* @ngInject */
    function abookEdit() {
        var directive = {
            bindToController: true,
            templateUrl: "abook-edit.tpl",
            controller: aBookEditCtrl,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.saving = false;
            scope.vm.saved = false;
            scope.getContacts();
        }
    }
    /* @ngInject */
    function aBookEditCtrl($scope,$http) {
        $scope.selectContact = function(id) {
            $scope.vm.contact = angular.copy($scope.vm.contacts.find(function(c) {
                return c.id == id;
            }));
            $scope.vm.deleteConfirmation = '';
        };

        $scope.getContacts = function() {
            $scope.ajaxIt('abook_contacts_list', {
                seller_id: $scope.vm.data.query[0].id
            },
            function(response) {
                $scope.vm.contacts = response.data.payload.contacts;
            });
        };

        $scope.contactSave = function() {
            $scope.ajaxIt('abook_contact_save', {
                seller_id: $scope.vm.data.query[0].id,
                first_name: $scope.vm.contact.first_name,
                last_name: $scope.vm.contact.last_name,
                email: $scope.vm.contact.email
            }, function(response) {
                var cidx = $scope.vm.contacts.findIndex(function(e) {
                    return e.email == $scope.vm.contact.email;
                });
                $scope.vm.contact.id = response.data.payload.id;
                if (cidx != -1) {
                    $scope.vm.contacts[cidx].first_name = $scope.vm.contact.first_name;
                    $scope.vm.contacts[cidx].last_name = $scope.vm.contact.last_name;
                    $scope.vm.contacts[cidx].email = $scope.vm.contact.email;
                } else {
                    $scope.vm.contacts.push(angular.copy($scope.vm.contact));
                }
                $scope.vm.saved = true;
                setTimeout(function() {
                    $scope.$apply(function() {
                        $scope.vm.saved = false;
                    });
                }, 3000);
            });
        };

        $scope.contactDelete = function() {
            $scope.vm.deleteConfirmation = "";
            $scope.ajaxIt('abook_contact_delete', {
                id: $scope.vm.contact.id
            },
            function(response) {
                var cidx = $scope.vm.contacts.findIndex(function(e) {
                    return e.id == $scope.vm.contact.id;
                });
                $scope.vm.contacts.splice(cidx, 1);
                $scope.vm.contact = null;
            });
        };

        $scope.ajaxIt = function(method, params, callback) {
            var adata = {
                action: 'pie_action',
                method: method,
                nonce: $scope.$root.stats.nonce,
                params: params
            };

            $scope.vm.saving = true;
            $http.post(window.ajaxurl, adata).then(function(response) {
                $scope.vm.saving = false;
                if (response.data.result) {
                    return callback(response);
                } else {
                    console.log('error');
                    return false;
                }

            });
        };
    }
})();